import apiPath from '../../../config/api';

const BalanceSheetPath = {
    title: "Neraca Keuangan",
    basePath: "/akunting/neraca",
    api: apiPath.accountBalance
}

export default BalanceSheetPath;
